import * as React from 'react';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {Table} from 'react-bootstrap';
import Alert from 'react-bootstrap/Alert';
import ReactPlayer from 'react-player';
import {Action, Help, Secondary, Trash} from '../../../system/buttons';
import {FileUploader} from '../../../system/file';

export default class SoundBpmEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...props.configuration,
      soundUrl: undefined,
      showRangePicker: false,
      speed: '1.0',
      volume: '100',
    };
  }

  handleRemove = (index) => () => {
    const ranges = [...this.state.ranges];
    ranges.splice(index, 1);
    this.setState({ranges});
  };

  handleRangeColorDraftComplete = (url) => {
    this.setState({soundUrl: url});
  };

  between(a, from, to) {
    return a >= from && a <= to;
  }

  handleNew = () => {
    const ranges = [...this.state.ranges];
    const concerns = [];

    if (!!!this.state.soundUrl) {
      concerns.push('choose the sound');
    }

    const from = parseInt(this.state.fromDraft);
    if (isNaN(from)) {
      concerns.push('from is not a number');
    }

    const to = parseInt(this.state.toDraft);
    if (isNaN(to)) {
      concerns.push('to is not a number');
    }
    if (to < from) {
      concerns.push('from is grater than to');
    }

    let index;

    for (index in ranges) {
      const current = ranges[index];
      if (this.between(from, current.from, current.to)) {
        concerns.push(
          from +
            ' (from) intersects with [' +
            current.from +
            ',' +
            current.to +
            ']'
        );
      }
      if (this.between(to, current.from, current.to)) {
        concerns.push(
          to + ' (to) intersect [' + current.from + ',' + current.to + ']'
        );
      }
    }

    if (concerns.length === 0) {
      ranges.push({
        from: from,
        to: to,
        soundUrl: this.state.soundUrl,
        speed: parseFloat(this.state.speed),
        volume: parseFloat(this.state.volume),
      });

      ranges.sort(function (a, b) {
        return a.from - b.from;
      });

      this.setState({ranges, concerns: undefined});
    } else {
      this.setState({concerns});
    }
  };

  handleFromChange = (event) => {
    this.setState({fromDraft: event.target.value});
  };

  handleToChange = (event) => {
    this.setState({toDraft: event.target.value});
  };

  handleFileUploaded = (fileUrl, name) => {
    let gallery = this.state.gallery;
    gallery.push({
      name: name.replace(/.*[/\\]/, ''),
      path: fileUrl,
    });
    this.setState({gallery}, () => this.saveConfiguration());
  };

  handlePictureDelete = (url) => () => {
    this.setState(
      {gallery: this.state.gallery.filter((entry) => entry.path !== url)},
      () => this.saveConfiguration()
    );
  };

  saveConfiguration = () => {
    this.props.onSave({
      ranges: this.state.ranges,
      gallery: this.state.gallery,
    });
  };

  render() {
    return (
      <>
        <div>
          <h4>Add new range</h4>

          <FileUploader onFileUploaded={this.handleFileUploaded} />

          <Form.Group as={Row}>
            <Form.Label column sm="2">
              From
            </Form.Label>
            <Col sm="3">
              <Form.Control type="number" onChange={this.handleFromChange} />
            </Col>
          </Form.Group>

          <Form.Group as={Row}>
            <Form.Label column sm="2">
              To
            </Form.Label>
            <Col sm="3">
              <Form.Control type="number" onChange={this.handleToChange} />
            </Col>
          </Form.Group>
        </div>

        <div>
          {
            <Form.Group as={Row}>
              <Form.Label column sm="2">
                Sound
              </Form.Label>

              <Col sm="3">
                <Table striped bordered size="sm">
                  <thead>
                    <tr>
                      <th
                        style={{
                          textAlign: 'center',
                        }}
                      >
                        Name
                      </th>
                      <th
                        style={{
                          textAlign: 'center',
                        }}
                      >
                        Sound
                      </th>
                      <th
                        style={{
                          textAlign: 'center',
                        }}
                      >
                        Delete
                      </th>
                      <th
                        style={{
                          textAlign: 'center',
                        }}
                      >
                        Select
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.gallery &&
                      this.state.gallery.map((entry) => {
                        let style = {};
                        if (entry.path === this.state.soundUrl) {
                          style.border = '5px solid black';
                        }

                        return (
                          <tr style={style}>
                            <td style={{textAlign: 'center'}}> {entry.name}</td>
                            <td style={{textAlign: 'center'}}>
                              <ReactPlayerFix
                                url={entry.path}
                                controls
                                volume={parseFloat(this.state.volume) / 100}
                                playbackRate={parseFloat(this.state.speed)}
                              />
                            </td>
                            <td style={{textAlign: 'center'}}>
                              <Trash
                                onClick={this.handlePictureDelete(entry.path)}
                              />
                            </td>
                            <td style={{textAlign: 'center'}}>
                              <Help
                                size="sm"
                                onClick={() =>
                                  this.setState({soundUrl: entry.path})
                                }
                              >
                                Select
                              </Help>
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </Table>
              </Col>
            </Form.Group>
          }
          <div>
            <Form.Group as={Row}>
              <Form.Label column sm="2">
                Speed
              </Form.Label>
              <Col sm="3">
                <Form.Control
                  as="select"
                  ref="speedSelect"
                  onChange={() =>
                    this.setState({speed: this.refs.speedSelect.value})
                  }
                >
                  <option>1.0</option>
                  <option>1.2</option>
                  <option>1.5</option>
                  <option>1.7</option>
                  <option>2.0</option>
                </Form.Control>
              </Col>
            </Form.Group>
          </div>

          <div>
            <Form.Group as={Row}>
              <Form.Label column sm="2">
                Volume(in %)
              </Form.Label>
              <Col sm="3">
                <Form.Control
                  as="select"
                  ref="volumeSelect"
                  onChange={() =>
                    this.setState({volume: this.refs.volumeSelect.value})
                  }
                >
                  <option>100</option>
                  <option>90</option>
                  <option>80</option>
                  <option>70</option>
                  <option>60</option>
                  <option>50</option>
                  <option>40</option>
                  <option>30</option>
                  <option>20</option>
                  <option>10</option>
                  <option>0</option>
                </Form.Control>
              </Col>
            </Form.Group>
          </div>

          <Form.Group>
            <Secondary onClick={this.handleNew} variant={'success'}>
              Add
            </Secondary>
          </Form.Group>
        </div>

        {this.state.concerns && (
          <Alert variant="warning">
            <h5>Can't add new range</h5>
            <ul>
              {this.state.concerns.map((concern) => (
                <li>{concern}</li>
              ))}
            </ul>
          </Alert>
        )}

        <hr />

        <h4>Configured ranges</h4>
        <Table striped bordered>
          <thead>
            <tr>
              <th
                style={{
                  textAlign: 'center',
                }}
              >
                Range
              </th>
              <th style={{textAlign: 'center'}}>Sound</th>
              <th
                style={{
                  textAlign: 'center',
                }}
              >
                Speed
              </th>
              <th
                style={{
                  textAlign: 'center',
                }}
              >
                Volume
              </th>
              <th
                style={{
                  textAlign: 'center',
                }}
              >
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {this.state.ranges.map((range, index) => {
              return (
                <tr>
                  <td style={{textAlign: 'center'}}>
                    {range.from} - {range.to}
                  </td>
                  <td style={{textAlign: 'center'}}>
                    <ReactPlayerFix
                      url={range.soundUrl}
                      controls
                      playbackRate={range.speed}
                      className={'audio'}
                      config={{file: {forceAudio: true}}}
                    />
                  </td>
                  <td style={{textAlign: 'center'}}>{range.speed}</td>

                  <td style={{textAlign: 'center'}}>{range.volume}</td>

                  <td style={{textAlign: 'center'}}>
                    <Trash onClick={this.handleRemove(index)} />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>

        <Action onClick={this.saveConfiguration}>Save settings</Action>
      </>
    );
  }
}

export class ReactPlayerFix extends React.Component {
  constructor(props) {
    super(props);
    this.id = `f${(+new Date()).toString(16)}`;
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    let playerWrapper = document.getElementById(this.id);
    if (playerWrapper) {
      playerWrapper.style.width = null;
      playerWrapper.style.height = null;
      if (playerWrapper.firstChild) {
        playerWrapper.firstChild.style.height = null;
        playerWrapper.firstChild.style.width = null;
      }
    }
  }

  componentDidMount(prevProps, prevState, snapshot) {
    let playerWrapper = document.getElementById(this.id);
    if (playerWrapper) {
      playerWrapper.style.width = null;
      playerWrapper.style.height = null;
      if (playerWrapper.firstChild) {
        playerWrapper.firstChild.style.height = null;
        playerWrapper.firstChild.style.width = null;
      }
    }
  }

  render() {
    return (
      <ReactPlayer
        id={this.id}
        volume={this.props.volume}
        ref={(ref) => (this.ref = ref)}
        url={this.props.url}
        controls
        playbackRate={this.props.playbackRate}
        config={{file: {forceAudio: true}}}
      />
    );
  }
}
